import store from '@/store'
import { DEVICE_TYPE } from '@/utils/device'

// 判断当前设备为pc
export function isDesktop() {
  return store.getters.device === DEVICE_TYPE.DESKTOP
}
// 判断当前设备为phone
export function isMobile() {
  return store.getters.device === DEVICE_TYPE.MOBILE
}
